import CheckIcon from '@mui/icons-material/Check';
import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';

const THUMB_SIZE = 18;

const DesignSwitch = styled(Switch)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  width: 34,
  height: 24,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 3,
    '&.Mui-checked': {
      transform: 'translateX(12px)',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.primary.main,
        opacity: 1,
        border: 0,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    width: THUMB_SIZE,
    height: THUMB_SIZE,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.common.white,
    boxShadow: theme.shadows[1],
  },
  '& .MuiSwitch-track': {
    width: 30,
    height: 14,
    borderRadius: 12,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === 'dark' ? theme.palette.shade?.[700] : theme.palette.shade?.[200],
  },
}));

export const DesignSwitchCheckIcon = <CheckIcon sx={{ fontSize: THUMB_SIZE - 4 }} />;

export default DesignSwitch;
